import { CloseOutlined, EyeOutlined } from '@ant-design/icons'
import { Image } from 'antd'
import { useState } from 'react'
import styles from './file.module.less'
import Video from './Video'

const FileC = (props) => {
  const { item, onThumbClick } = props
  if (item.isImg) {
    return (
      <img
        src={item.url}
        className={styles.img}
        alt={item.name}
        onClick={onThumbClick}
      />
    )
  }
  if (item.isVideo) {
    return (
      <video
        src={item.url}
        className={styles.video}
        onClick={onThumbClick}
      ></video>
    )
  }
  return (
    <div className={styles.text}>
      <span>{item.name}</span>
    </div>
  )
}

const actionNameMap = {
  delete: '删除'
}

const FileComp = (props) => {
  const { item, action, onAction } = props
  let actionName = actionNameMap[action]
  const isPreview = action === 'preview'
  const isDelete = action === 'delete'
  if (isPreview) {
    actionName = item.isVideo ? '预览' : '下载'
  }
  const [showVideo, setShowVideo] = useState(false)

  const openVideoPreview = () => {
    if (item.isVideo) {
      setShowVideo(true)
    }
  }

  if (isDelete) {
    return (
      <div className={styles.fileWrapper}>
        {item.isImg ? (
          <Image
            src={item.url}
            alt={item.name}
            rootClassName={styles.imageRoot}
            preview={{ src: item.url }}
          />
        ) : (
          <FileC item={item} onThumbClick={openVideoPreview} />
        )}
        <span
          className={styles.deleteBadge}
          onClick={(e) => {
            e.stopPropagation()
            onAction()
          }}
          role="button"
          tabIndex={0}
          aria-label="删除"
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              e.stopPropagation()
              onAction()
            }
          }}
        >
          <CloseOutlined />
        </span>
        <Video
          src={item.url}
          visible={showVideo}
          setVisible={setShowVideo}
        ></Video>
      </div>
    )
  }

  const handleAction = () => {
    if (isPreview && item.isVideo) {
      setShowVideo(true)
    } else {
      onAction()
    }
  }

  if (!actionName) return <FileC item={item}></FileC>
  return (
    <div className={styles.fileWrapper}>
      <FileC item={item}></FileC>
      <div className={styles.fileMask}>
        <span className={styles.fileAction} onClick={handleAction}>
          {actionName === '预览' && (
            <EyeOutlined className={styles.previewIcon} />
          )}
          <span>{actionName}</span>
        </span>
      </div>
      <Video
        src={item.url}
        visible={showVideo}
        setVisible={setShowVideo}
      ></Video>
    </div>
  )
}

export default FileComp
